// Third party libraries
import { useSelector } from 'react-redux';
// Components
import { Estimates } from '../Components/estimates/Estimates';
import { Footer } from '../Components/footer/Footer';
import { Header } from '../Components/header/Header';
import { Promo } from '../Components/promo/Promo';
// Methods for work with client store
import { getAuthenticatedStatus } from '../clientStore/authSlice/auth-slice';
import { PageHeader } from '../Components/page-header/Page-header';
import { PageHeaderWOB } from '../Components/page-header-wob/Page-header-wob';

export default function Main() {
  return (
    <div className='container'>
      <Header
        isLoginBtnShow={!useSelector(getAuthenticatedStatus)}
      />
      <PageHeaderWOB/>
      <main className='main'>
        <Promo />
        <Estimates />
      </main>
      {/* <Footer /> */}
    </div>
  )
};
